// src/pages/ReceivePage.js

import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { message } from "antd";
import {
  ArrowLeftIcon,
  DocumentDuplicateIcon,
  CheckCircleIcon,
  UserIcon,
  PhoneIcon,
  QrCodeIcon,
  LockClosedIcon,
} from "@heroicons/react/24/outline";
import { QRCodeCanvas } from "qrcode.react";

import "../components/Walletview.css"; // ← contains .market-back-btn
import "../pages/Receive.css";

const ReceivePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { wallet, baitcashAccount } = location.state || {};
  const [copied, setCopied] = useState(false);

  if (!wallet || !baitcashAccount) {
    navigate("/dashboard");
    return null;
  }

  const goBack = () => navigate("/dashboard");

  const handleCopy = () => {
    if (!baitcashAccount?.phoneNumber) return;
    navigator.clipboard.writeText(baitcashAccount.phoneNumber);
    setCopied(true);
    message.success("Phone number copied");
    setTimeout(() => setCopied(false), 2000);
  };

  // =====================================================
  // TITLE STYLES — matches BAIT PAY brand
  // =====================================================
  const titleStyle = {
    margin: "0 0 5px",

    fontFamily:
      "'Inter', 'Poppins', 'Segoe UI', sans-serif",

    fontSize: 26,

    lineHeight: 1.1,

    fontWeight: 600,

    letterSpacing: "1.4px",

    color: "#8a5a1f",

    WebkitTextStroke: "0.4px #6b3d0a",

    textShadow:
      "0 1px 0 rgba(255, 240, 200, 0.6), 0 2px 6px rgba(154, 106, 24, 0.22)",
  };

  const subtitleStyle = {
    margin: "4px 0 0",

    fontFamily:
      "'Poppins', 'Segoe UI', sans-serif",

    fontSize: 11,

    fontWeight: 500,

    letterSpacing: "0.6px",

    lineHeight: 1.3,

    color: "#a07a3f",

    opacity: 0.95,
  };

  return (
    <div className="receive-page">
      {/* =====================================================
          PAGE TITLE
      ===================================================== */}
      <div className="receive-page-title">
        {/* BACK BUTTON — uses shared .market-back-btn styles */}
        <button
          type="button"
          className="market-back-btn"
          onClick={goBack}
          title="Back to Dashboard"
          aria-label="Back to Dashboard"
        >
          <ArrowLeftIcon width={18} height={18} />
        </button>

        <h1 style={titleStyle}>Receive PKR</h1>
        <p style={subtitleStyle}>QR code to receive payments</p>
      </div>

      {/* =====================================================
          QR CODE
      ===================================================== */}
      <div className="receive-qr-container">
        <div className="receive-qr-wrapper">
          <div className="receive-qr-code">
            <QRCodeCanvas
              value={`BAITCASH:${baitcashAccount.phoneNumber}`}
              size={170}
              bgColor="#ffffff"
              fgColor="#1a1a1a"
              level="H"
              includeMargin={true}
            />
          </div>
          <div className="receive-qr-label">
            <UserIcon
              width={14}
              height={14}
              style={{ display: "inline", marginRight: "4px" }}
            />
            {baitcashAccount.fullName}
          </div>
        </div>
      </div>

      {/* =====================================================
          PHONE NUMBER SECTION
      ===================================================== */}
      <div className="receive-address-section">
        <div className="receive-address-label">Phone Number</div>
        <div className="receive-address-box">
          <div className="receive-address">
            <PhoneIcon
              width={14}
              height={14}
              style={{
                display: "inline",
                marginRight: "6px",
                color: "#9a6a18",
              }}
            />
            {baitcashAccount.phoneNumber}
          </div>
          <button
            className={`receive-copy-btn ${copied ? "copied" : ""}`}
            onClick={handleCopy}
            aria-label="Copy phone number"
          >
            {copied ? <CheckCircleIcon /> : <DocumentDuplicateIcon />}
          </button>
        </div>
        <div className="receive-address-short">Tap to copy</div>
      </div>

      {/* =====================================================
          INFORMATION NOTE
      ===================================================== */}
      <div className="receive-info">
        <p>
          <QrCodeIcon
            width={16}
            height={16}
            style={{
              display: "inline",
              marginRight: "6px",
              color: "#9a6a18",
            }}
          />
          Anyone with this QR code can send you PKR directly.
        </p>
        <p>Your BAIT Cash balance will update automatically.</p>
        <p
          style={{
            marginTop: "8px",
            borderTop: "1px solid #eee",
            paddingTop: "8px",
            fontSize: "11px",
          }}
        >
          <LockClosedIcon
            width={14}
            height={14}
            style={{
              display: "inline",
              marginRight: "4px",
              color: "#9a6a18",
            }}
          />
          Secure • Instant • 24/7 — Your payments are protected with
          bank-level security
        </p>
      </div>
    </div>
  );
};

export default ReceivePage;